(function () {
  const ELEMENT_NAME = 'klaviyo-bis';
  const BIS_REVISION = '2026-04-15';
  const SUBSCRIPTIONS_REVISION = '2026-04-15';

  const FALLBACKS = {
    title: 'Back in stock',
    description: "Leave your email and we'll notify you.",
    buttonLabel: 'Notify me',
    successMessage: "You're on the list!",
    closeLabel: 'Close',
    emailLabel: 'Email',
    emailPlaceholder: 'name@example.com',
    invalidEmail: 'Invalid email address',
    configurationError: 'Configuration error',
    genericError: 'Something went wrong',
    requestFailedError: 'Request failed. Please try again.'
  };

  const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const FOCUSABLE_SELECTOR = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  const BIS_STYLE = `
    :host {
      color: #171717;
      font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
    }

    dialog.bis-dialog {
      width: min(100% - 32px, 520px);
      max-width: 520px;
      margin: auto;
      padding: 0;
      color: inherit;
      background: transparent;
      border: 0;
      overflow: visible;
    }

    dialog.bis-dialog::backdrop {
      background: rgb(0 0 0 / 0);
      transition: background 220ms ease, overlay 220ms allow-discrete, display 220ms allow-discrete;
    }

    dialog.bis-dialog[open]::backdrop {
      background: rgb(0 0 0 / 0.45);
    }

    @starting-style {
      dialog.bis-dialog[open]::backdrop {
        background: rgb(0 0 0 / 0);
      }
    }

    .bis-form-wrap {
      position: relative;
      display: grid;
      gap: 18px;
      padding: 32px;
      color: #171717;
      background: #ffffff;
      border-top: 2px solid #171717;
      border-radius: 16px;
      box-shadow: 0 24px 80px rgb(0 0 0 / 0.1);
      transition: transform 260ms cubic-bezier(0.16, 1, 0.3, 1);
    }

    @starting-style {
      dialog.bis-dialog[open] .bis-form-wrap {
        transform: translateY(14px) scale(0.98);
      }
    }

    .bis-title {
      margin: 0;
      padding-inline-end: 40px;
      font-size: clamp(1.5rem, 4vw, 2rem);
      line-height: 1.15;
      font-weight: 700;
      letter-spacing: -0.02em;

    }

    .bis-desc {
      margin: -2px 0 0;
      color: #666666;
      font-size: 1rem;
      line-height: 1.5;
    }

    .bis-divider {
      width: 100%;
      height: 1px;
      margin: 0;
      background: #e5e5e5;
      border: 0;
    }

    .bis-form {
      display: grid;
      gap: 14px;
    }

    .bis-field {
      display: grid;
      gap: 7px;
    }

    .bis-email-label {
      font-size: 0.75rem;
      font-weight: 700;
      letter-spacing: 0.08em;
      line-height: 1.2;
      text-transform: uppercase;
    }

    .bis-email {
      width: 100%;
      box-sizing: border-box;
      padding: 13px 14px;
      color: #171717;
      background: #ffffff;
      border: 1px solid #bdbdbd;
      border-radius: 8px;
      font: inherit;
      transition: border-color 160ms ease, box-shadow 160ms ease;
    }

    .bis-email:focus {
      border-color: #171717;
      outline: none;
      box-shadow: 0 0 0 3px rgb(23 23 23 / 0.12);
    }

    .bis-email[aria-invalid="true"] {
      border-color: #b42318;
    }

    .bis-consent {
      display: flex;
      gap: 10px;
      align-items: flex-start;
      color: #4b4b4b;
      font-size: 0.875rem;
      line-height: 1.4;
    }

    .bis-consent input {
      flex: 0 0 auto;
      width: 18px;
      height: 18px;
      margin: 1px 0 0;
      accent-color: #171717;
    }

    .bis-submit {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      min-height: 48px;
      padding: 12px 18px;
      color: #ffffff;
      background: #171717;
      border: 1px solid #171717;
      border-radius: 999px;
      font: inherit;
      font-weight: 700;
      cursor: pointer;
      transition: opacity 160ms ease;
    }

    .bis-submit:hover {
      opacity: 0.86;
    }

    .bis-submit:disabled {
      cursor: wait;
      opacity: 0.62;
    }

    .bis-close {
      position: absolute;
      inset-block-start: 18px;
      inset-inline-end: 18px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 40px;
      height: 40px;
      padding: 0;
      color: #171717;
      background: transparent;
      border: 0;
      border-radius: 999px;
      cursor: pointer;
      transition: background 160ms ease;
    }

    .bis-close:hover {
      background: #f2f2f2;
    }

    .bis-close svg {
      width: 20px;
      height: 20px;
    }

    .bis-error {
      min-height: 1.25em;
      margin: -2px 0 0;
      color: #b42318;
      font-size: 0.875rem;
      line-height: 1.4;
    }

    .bis-error:empty {
      display: none;
    }

    .bis-success {
      display: grid;
      gap: 14px;
      padding-block: 12px 4px;
    }

    .bis-success strong {
      font-size: 1.125rem;
      line-height: 1.3;
    }

    [hidden] {
      display: none !important;
    }

    :is(button, input):focus-visible {
      outline: 2px solid #171717;
      outline-offset: 3px;
    }

    @keyframes bis-out {
      from {
        opacity: 1;
        transform: scale(1) translateY(0);
      }
      to {
        opacity: 0;
        transform: scale(0.97) translateY(8px);
      }
    }

    @keyframes bis-backdrop-out {
      from { opacity: 1; }
      to { opacity: 0; }
    }

    dialog.bis-dialog.bis-closing .bis-form-wrap {
      animation: bis-out 180ms ease-in both;
    }

    dialog.bis-dialog.bis-closing::backdrop {
      animation: bis-backdrop-out 180ms ease-in both;
    }

    @media (max-width: 520px) {
      .bis-form-wrap {
        padding: 28px 22px;
        border-radius: 14px;
      }
    }

    @media (prefers-reduced-motion: reduce) {
      *,
      *::before,
      *::after {
        transition: none !important;
        animation: none !important;
        scroll-behavior: auto !important;
      }
    }
  `;

  class KlaviyoBis extends HTMLElement {
    #abortController = null;
    #dialog = null;
    #emailInput = null;
    #error = null;
    #form = null;
    #lastTrigger = null;
    #submitButton = null;

    connectedCallback() {
      if (!this.shadowRoot) {
        this.attachShadow({ mode: 'open' });
      }

      this.#render();
      this.#bind();
    }

    disconnectedCallback() {
      this.#abortController?.abort();
    }

    open(options = {}) {
      const variantId = options.variantId || this.getAttribute('variant-id') || '';
      const listId = options.listId || this.getAttribute('list-id') || '';

      if (variantId) {
        this.setAttribute('variant-id', variantId);
      }

      if (listId) {
        this.setAttribute('resolved-list-id', listId);
      } else {
        this.removeAttribute('resolved-list-id');
      }

      this.#lastTrigger = options.trigger || null;
      this.#resetState();

      if (this.#dialog?.open) {
        return;
      }

      this.#dialog?.showModal();
      requestAnimationFrame(() => this.#emailInput?.focus());
    }

    #bind() {
      if (!this.#dialog || !this.#form) {
        return;
      }

      this.#form.addEventListener('submit', (event) => {
        event.preventDefault();
        this.#submit();
      });

      this.#dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        this.#closeWithAnimation();
      });

      this.#dialog.addEventListener('click', (event) => {
        if (event.target === this.#dialog) {
          this.#closeWithAnimation();
        }
      });

      this.shadowRoot.querySelector('[data-bis-close]')?.addEventListener('click', () => {
        this.#closeWithAnimation();
      });
    }

    #render() {
      const titleId = `${this.id || 'KlaviyoBis'}-Title`;
      const errorId = `${this.id || 'KlaviyoBis'}-Error`;
      const newsletterLabel = this.getAttribute('newsletter-label') || '';

      this.shadowRoot.innerHTML = `
        <style>${BIS_STYLE}</style>
        <dialog class="bis-dialog" aria-modal="true" aria-labelledby="${titleId}">
          <div class="bis-form-wrap">
            <button class="bis-close" type="button" data-bis-close aria-label="${this.#attr('close-label', FALLBACKS.closeLabel)}">
              <svg aria-hidden="true" viewBox="0 0 20 20" fill="none">
                <path d="M5 5l10 10M15 5L5 15" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
              </svg>
            </button>

            <div data-bis-form-state>
              <h2 class="bis-title" id="${titleId}">${this.#attr('title', FALLBACKS.title)}</h2>
              <p class="bis-desc">${this.#attr('description', FALLBACKS.description)}</p>
            </div>

            <hr class="bis-divider" data-bis-form-state>

            <form class="bis-form" novalidate data-bis-form data-bis-form-state>
              <div class="bis-field">
                <label class="bis-email-label" for="KlaviyoBisEmail">${this.#attr('email-label', FALLBACKS.emailLabel)}</label>
                <input
                  class="bis-email"
                  id="KlaviyoBisEmail"
                  type="email"
                  autocomplete="email"
                  inputmode="email"
                  required
                  aria-required="true"
                  aria-describedby="${errorId}"
                  placeholder="${this.#attr('email-placeholder', FALLBACKS.emailPlaceholder)}"
                >
              </div>

              <label class="bis-consent" ${newsletterLabel ? '' : 'hidden'}>
                <input type="checkbox" data-bis-newsletter>
                <span>${newsletterLabel}</span>
              </label>

              <p class="bis-error" id="${errorId}" role="alert" data-bis-error></p>

              <button class="bis-submit" type="submit" data-bis-submit>
                ${this.#attr('button-label', FALLBACKS.buttonLabel)}
              </button>
            </form>

            <div class="bis-success" data-bis-success hidden>
              <strong>${this.#attr('success-message', FALLBACKS.successMessage)}</strong>
              <button class="bis-submit" type="button" data-bis-close>${this.#attr('close-label', FALLBACKS.closeLabel)}</button>
            </div>
          </div>
        </dialog>
      `;

      this.#dialog = this.shadowRoot.querySelector('dialog');
      this.#emailInput = this.shadowRoot.querySelector('.bis-email');
      this.#error = this.shadowRoot.querySelector('[data-bis-error]');
      this.#form = this.shadowRoot.querySelector('[data-bis-form]');
      this.#submitButton = this.shadowRoot.querySelector('[data-bis-submit]');
    }

    #attr(name, fallback) {
      return escapeHtml(this.getAttribute(name) || fallback);
    }

    #resetState() {
      this.#abortController?.abort();
      this.#abortController = null;
      this.#form?.reset();
      this.#setError('');
      this.#setLoading(false);

      this.shadowRoot.querySelectorAll('[data-bis-form-state]').forEach((element) => {
        element.hidden = false;
      });

      const success = this.shadowRoot.querySelector('[data-bis-success]');
      if (success) {
        success.hidden = true;
      }
    }

    async #submit() {
      const accountId = this.getAttribute('account-id') || '';
      const variantId = this.getAttribute('variant-id') || '';
      const email = this.#emailInput?.value.trim() || '';

      this.#setError('');
      this.#emailInput?.setAttribute('aria-invalid', 'false');

      if (!accountId || !variantId) {
        this.#setError(this.getAttribute('configuration-error') || FALLBACKS.configurationError);
        return;
      }

      if (!EMAIL_PATTERN.test(email)) {
        this.#emailInput?.setAttribute('aria-invalid', 'true');
        this.#setError(this.getAttribute('invalid-email-error') || FALLBACKS.invalidEmail);
        this.#emailInput?.focus();
        return;
      }

      this.#abortController?.abort();
      this.#abortController = new AbortController();
      this.#setLoading(true);

      try {
        await this.#subscribeBackInStock({ accountId, variantId, email });

        const newsletterCheckbox = this.shadowRoot.querySelector('[data-bis-newsletter]');
        const listId = this.getAttribute('resolved-list-id') || this.getAttribute('list-id') || '';
        if (newsletterCheckbox?.checked && listId) {
          await this.#subscribeNewsletter({ accountId, listId, email });
        }

        this.#showSuccess();
      } catch (error) {
        if (error.name === 'AbortError') {
          return;
        }

        this.#setError(this.getAttribute('request-failed-error') || FALLBACKS.requestFailedError);
      } finally {
        this.#setLoading(false);
      }
    }

    async #subscribeBackInStock({ accountId, variantId, email }) {
      const url = new URL('https://a.klaviyo.com/client/back-in-stock-subscriptions/');
      url.searchParams.set('company_id', accountId);

      const response = await fetch(url.toString(), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          revision: BIS_REVISION
        },
        signal: this.#abortController.signal,
        body: JSON.stringify({
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              profile: {
                data: {
                  type: 'profile',
                  attributes: { email }
                }
              },
              channels: ['EMAIL']
            },
            relationships: {
              variant: {
                data: {
                  type: 'catalog-variant',
                  id: `$shopify:::$default:::${variantId}`
                }
              }
            }
          }
        })
      });

      if (!response.ok) {
        throw new Error(`Klaviyo BIS request failed: ${response.status}`);
      }
    }

    async #subscribeNewsletter({ accountId, listId, email }) {
      const url = new URL('https://a.klaviyo.com/client/subscriptions/');
      url.searchParams.set('company_id', accountId);

      const response = await fetch(url.toString(), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          revision: SUBSCRIPTIONS_REVISION
        },
        signal: this.#abortController.signal,
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              profile: {
                data: {
                  type: 'profile',
                  attributes: { email }
                }
              }
            },
            relationships: {
              list: {
                data: {
                  type: 'list',
                  id: listId
                }
              }
            }
          }
        })
      });

      if (!response.ok) {
        throw new Error(`Klaviyo subscription request failed: ${response.status}`);
      }
    }

    #showSuccess() {
      this.shadowRoot.querySelectorAll('[data-bis-form-state]').forEach((element) => {
        element.hidden = true;
      });

      const success = this.shadowRoot.querySelector('[data-bis-success]');
      if (success) {
        success.hidden = false;
        success.querySelector(FOCUSABLE_SELECTOR)?.focus();
      }
    }

    #setLoading(isLoading) {
      if (!this.#submitButton) {
        return;
      }

      this.#submitButton.disabled = isLoading;
      this.#submitButton.setAttribute('aria-busy', String(isLoading));
    }

    #setError(message) {
      if (this.#error) {
        this.#error.textContent = message;
      }
    }

    #closeWithAnimation() {
      if (!this.#dialog?.open) {
        return;
      }

      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (prefersReducedMotion) {
        this.#closeNow();
        return;
      }

      this.#dialog.classList.add('bis-closing');

      const closeAfterAnimation = () => {
        this.#dialog?.removeEventListener('animationend', closeAfterAnimation);
        this.#closeNow();
      };

      this.#dialog.addEventListener('animationend', closeAfterAnimation, { once: true });
      window.setTimeout(closeAfterAnimation, 240);
    }

    #closeNow() {
      this.#dialog?.classList.remove('bis-closing');
      if (this.#dialog?.open) {
        this.#dialog.close();
      }
      this.#lastTrigger?.focus?.();
    }
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function getTriggerHost(trigger) {
    const hostId = trigger.getAttribute('data-bis-host-id');
    if (hostId) {
      return document.getElementById(hostId);
    }

    return document.querySelector(ELEMENT_NAME);
  }

  function updateTriggersForVariant(variant) {
    if (!variant?.id) {
      return;
    }

    document.querySelectorAll('[data-bis-trigger]').forEach((trigger) => {
      trigger.setAttribute('data-variant-id', String(variant.id));
    });

    document.querySelectorAll('[data-bis-sold-out-only]').forEach((wrapper) => {
      wrapper.hidden = variant.available === true;
    });
  }

  if (!customElements.get(ELEMENT_NAME)) {
    customElements.define(ELEMENT_NAME, KlaviyoBis);
  }

  if (!window.__klaviyoBisListenersBound) {
    window.__klaviyoBisListenersBound = true;

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest?.('[data-bis-trigger]');
      if (!trigger) {
        return;
      }

      const host = getTriggerHost(trigger);
      if (!host || typeof host.open !== 'function') {
        return;
      }

      event.preventDefault();
      host.open({
        trigger,
        variantId: trigger.getAttribute('data-variant-id') || '',
        listId: trigger.getAttribute('data-list-id') || ''
      });
    });

    document.addEventListener('variant:change', (event) => {
      updateTriggersForVariant(event.detail?.variant);
    });
  }
})();
